import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMBergenPaymentTermAsync,
  deleteOMBergenPaymentTermAsync,
  editOMBergenPaymentTermAsync,
  getOMBergenPaymentTermAsync,
} from "../../../store/services/orderManagementService";
const BergenPaymentTerm = () => {
  const dispatch = useDispatch();
  const {
    getOMBergenPaymentTermStatus,
    getOMBergenPaymentTermError,
    getOMBergenPaymentTermData,
    addOMBergenPaymentTermStatus,
    addOMBergenPaymentTermData,
    addOMBergenPaymentTermError,

    editOMBergenPaymentTermStatus,
    editOMBergenPaymentTermError,
    editOMBergenPaymentTermData,

    deleteOMBergenPaymentTermData,
    deleteOMBergenPaymentTermStatus,
    deleteOMBergenPaymentTermError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMBergenPaymentTermAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMBergenPaymentTermData?.length
    ? getOMBergenPaymentTermData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedBergenPaymentTerm, setSelectedBergenPaymentTerm] = useState();
  const [addBergenPaymentTermMode, setAddBergenPaymentTermMode] = useState(false);
  const [addBergenPaymentTermData, setAddBergenPaymentTermData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedBergenPaymentTerm", selectedBergenPaymentTerm);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMBergenPaymentTermStatus === asyncStatus.SUCCEEDED) {
      setAddBergenPaymentTermMode(false);
      setSaveDisabled(true);
      setAddBergenPaymentTermData();
    }
  }, [, addOMBergenPaymentTermStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMBergenPaymentTermAsync(selectedBergenPaymentTerm?.bergen_payment_term_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMBergenPaymentTermStatus === asyncStatus.SUCCEEDED || deleteOMBergenPaymentTermStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedBergenPaymentTerm();
    }
  }, [, deleteOMBergenPaymentTermStatus]);
  useEffect(() => {
    if (editOMBergenPaymentTermStatus === asyncStatus.SUCCEEDED) {
      setSelectedBergenPaymentTerm();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMBergenPaymentTermStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this bergen payment term?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Bergen Payment Term"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Bergen Payment Term
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddBergenPaymentTermMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addBergenPaymentTermMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addBergenPaymentTermMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddBergenPaymentTermMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addBergenPaymentTermMode || !selectedBergenPaymentTerm}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMBergenPaymentTermStatus === asyncStatus.LOADING ||
                  editOMBergenPaymentTermStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addBergenPaymentTermData) {
                    dispatch(addOMBergenPaymentTermAsync(addBergenPaymentTermData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedBergenPaymentTerm, ...editData };
                    delete a.id;
                    dispatch(editOMBergenPaymentTermAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "bergen_payment_term_id", headerName: "ID", flex: true },
                  { field: "term_description", headerName: "Bergen Payment Term", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedBergenPaymentTerm(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMBergenPaymentTermStatus === asyncStatus.IDLE ||
                  getOMBergenPaymentTermStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addBergenPaymentTermMode ? (
              <InputWithBtnLayoutComp
              error={addOMBergenPaymentTermError}
                inputArray={[
                  {
                    label: "Bergen Payment Term:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddBergenPaymentTermData({
                            ...addBergenPaymentTermData,
                            term_description: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddBergenPaymentTermData({
                            ...addBergenPaymentTermData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedBergenPaymentTerm ? (
              <InputWithBtnLayoutComp
              error={editOMBergenPaymentTermError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedBergenPaymentTerm?.bergen_payment_term_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "BergenPaymentTerm:",
                    comp: (
                      <InputComp
                        key={selectedBergenPaymentTerm?.bergen_payment_term_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            term_description: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedBergenPaymentTerm?.term_description}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedBergenPaymentTerm?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedBergenPaymentTerm?.is_active || editData?.is_active}
                        defaultChecked={selectedBergenPaymentTerm?.is_active || editData?.is_active}
                        // checked={selectedBergenPaymentTerm?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any bergen payment term</Typography>
              <Typography color={"red"} fontSize={12}>{getOMBergenPaymentTermError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedBergenPaymentTerm(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedBergenPaymentTerm(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default BergenPaymentTerm;
